import { render, staticRenderFns } from "./QueryTapirMd.vue?vue&type=template&id=3295d050&scoped=true&"
import script from "./QueryTapirMd.vue?vue&type=script&lang=js&"
export * from "./QueryTapirMd.vue?vue&type=script&lang=js&"
import style0 from "./QueryTapirMd.vue?vue&type=style&index=0&id=3295d050&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3295d050",
  null
  
)

export default component.exports